import { cusAxios, PREFIX } from './main';

export const ENUM_DATE_MEDE = { register: 'register', firstDep: 'firstDep' };

const getGamerList = async ({
  groupId,
  currency,
  refcodeId,
  minDepositCount,
  dateMode,
  dateFrom,
  dateTo,
  pageSize,
  pageNo,
  userId,
  userLogin
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/report/gamers`,
    data: {
      groupId,
      currency,
      refcodeId,
      minDepositCount,
      dateMode,
      dateFrom,
      dateTo,
      pageSize,
      pageNo,
      userId,
      userLogin
    }
  });
  return response;
};

const getBonusList = async ({ groupId, currency, dateFrom, dateTo }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/report/bonuses`,
    data: { groupId, currency, dateFrom, dateTo }
  });
  return response;
};

const getRefcode = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/report/refcodes`,
    data: data
  });
  return response;
};

const refcodesByGroup = async ({ groupId, recursive }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/group/refcode_list`,
    data: { groupId, recursive }
  });
  return response;
};

export const API_REPORT = {
  list: {
    gamers: getGamerList,
    bonuses: getBonusList,
    refcode: { refcodes: refcodesByGroup, fullList: getRefcode }
  }
};
